import styled from "styled-components";
import { getMarginStyle, getPaddingStyle } from "core/styles/paddingMarginStyle";
import { CircleProps } from ".";

export const CircleStyled = styled.div<CircleProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  background-color: ${({ color, theme }) => color || theme?.colors?.primary.default};
  border-radius: 50%;
  border: ${({ borderColor }) => `1px solid ${borderColor}`};

  ${getMarginStyle}
  ${getPaddingStyle}
`;
